import Service from './service';


export default class VoiceService extends Service {

  constructor(service, address_details) {
    super(service);
  }

}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/voice-service.js